import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsInlineSkateNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.25 0v.08c0 .36.14.699.381.95L4.687.335c.5-.33 1.123-.413 1.692-.225l2.513.829a1.958 1.958 0 011.342 1.77H11v1.25h-.723c.11.628.44 1.2.935 1.613l.346-.346.884.884-.217.217c.26.178.552.304.861.37l.598.13A2.94 2.94 0 0116 9.7c0 .47-.21.892-.54 1.176l.071.108c.324.485.311 1.053.071 1.5a1.5 1.5 0 11-2.582.767h-1.04a1.5 1.5 0 11-2.959 0H7.979a1.5 1.5 0 11-2.959 0H3.98a1.5 1.5 0 11-2.569-.781 1.445 1.445 0 01-.074-1.19l.671-1.79a3.472 3.472 0 01-.372-2.602l1.222-4.866A2.625 2.625 0 012 .081V0zm2.737 1.296a.708.708 0 00-.612.081l-1.265.835a.042.042 0 00-.018.025L3.42 4.913l.022-.022 1.58 1.58a.708.708 0 001.067-.076l1.265-1.687H9.18a3.954 3.954 0 01-.165-.75H5.667v-1.25H8.98a.708.708 0 00-.481-.583zM9.85 5.958H7.98l-.89 1.187a1.958 1.958 0 01-2.952.21L3.074 6.29l-.226.9A2.222 2.222 0 003.178 9H5.57c1.15 0 1.757.297 2.298.565l.01.005c.465.23.87.43 1.733.43h4.838a.3.3 0 00.301-.3 1.69 1.69 0 00-1.331-1.652l-.598-.13a3.7 3.7 0 01-1.42-.645l-.071-.052-1.888 1.888-.884-.884 1.767-1.768a3.956 3.956 0 01-.475-.499zm-7.343 5.76a.208.208 0 00.195.282h11.616a.208.208 0 00.173-.324l-.284-.426H9.611c-1.15 0-1.757-.297-2.298-.565l-.01-.005c-.465-.23-.869-.43-1.733-.43H3.058z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsInlineSkateNormalXsmall;
